import { api_verify_recaptcha_token_path } from '../../routes';
import { SuccessResponse } from '../interfaces';
import request from './request';

export interface VerifyReCaptchaParams {
  recaptcha_token: string;
}

export const verifyReCaptchaToken = async (
  params: VerifyReCaptchaParams
): Promise<SuccessResponse> => {
  const response = await request('post', api_verify_recaptcha_token_path(params));
  return response;
};
